import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { Button } from "./ui/button";

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookie_accepted");
    if (!accepted) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-sm text-foreground max-w-3xl">
          {t("cookie.message")}{" "}
          <Link to="/datenschutz" className="underline font-medium text-[#0055FF]">
            {t("cookie.privacyLink")}
          </Link>
          .
        </p>
        <Button
          data-testid="cookie-accept-button"
          onClick={() => {
            localStorage.setItem("cookie_accepted", "1");
            setVisible(false);
          }}
          className="bg-[#0055FF] hover:bg-[#0044CC] text-white shrink-0"
          style={{ borderRadius: 4 }}
        >
          {t("cookie.accept")}
        </Button>
      </div>
    </div>
  );
}
